import { getAgentConfig } from '../api/weChat.js'
const weChatMixin = {
    methods: {
        async wxAgentConfig(url, wxApi, fn) {
            // const wx = window.wx
            const res = await getAgentConfig({ url })
            if(res.code == 0){
                wx.agentConfig({
                    debug: true,
                    corpid: res.data.corpid,
                    agentid: res.data.agentid,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature: res.data.signature,
                    jsApiList: Array.isArray(wxApi) && wxApi.length > 0 ? wxApi : [],
                    success: () => {
                        if(fn && typeof fn === 'function'){
                            fn()
                        }
                    },
                    fail: (res) => {
                        console.error(res)
                        // alert(res.errMsg)
                    }
                })
            }
        }
    }
}
export default weChatMixin